import React, { useContext } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { Container, Stack, Snackbar, Alert, Backdrop, CircularProgress } from "@mui/material";

import { AppContext } from "./context/AppProvider";
import { Configurator } from "./pages/configurator/Configurator";
import { Checkout } from "./pages/checkout/Checkout";
import { Summary } from "./pages/summary/Summary";
import { Activation } from "./pages/activation/Activation";
import { License } from "./pages/license/License";

const styles = {
  backdrop: {
    color: "#003459",
    zIndex: (theme) => theme.zIndex.drawer + 1
  }
};

export const App = () => {
  const { error, isProcessing, setError } = useContext(AppContext);
  const navigate = useNavigate();

  const onErrorClosed = () => {
    if (error && error.fatal) {
      window.localStorage.clear();
      navigate("/configure");
    }

    setError("");
  }

  return (
    <Container sx={{maxWidth: '100%!important'}}>
      <Backdrop sx={styles.backdrop} open={isProcessing}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Snackbar
        open={!!error.message}
        autoHideDuration={5000}
        onClose={onErrorClosed}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={onErrorClosed} severity="error" sx={{ width: '100%' }}>
          {error.message}
        </Alert>
      </Snackbar>

      <Stack direction="column">
        <Routes>
        <Route path="/" element={
              <Configurator />
          } />

          <Route path="/configure" element={
              <Configurator />
          } />

          <Route path="/checkout" element={
              <Checkout />
          } />

          <Route path="/summary" element={
              <Summary />
          } />

          <Route path="/activate" element={<Activation />} />
          <Route path="/license" element={<License />} />
        </Routes>
      </Stack>
    </Container >
  )
}